/** ESCHER FALLS — Português (Brasil)。 */

import type { Strings } from './ja';

export const PT: Strings = {
  pour: 'Soltar',
  lever: 'Alavanca',
  leverAria: 'Acionar a alavanca',
  retry: 'Reiniciar',
  again: 'De novo',
  next: 'Próximo',
  share: 'Compartilhar esta imagem',
  shareFailed: 'Não foi possível compartilhar',
  rotateLeft: 'Girar a vista para a esquerda',
  rotateRight: 'Girar a vista para a direita',
  tiltUp: 'Levantar a vista',
  tiltDown: 'Abaixar a vista',
  topDown: 'De cima',
  water: (left, total) => `Água ${left} / ${total}`,
  moves: (left, total) => `Giros ${left} / ${total}`,
  timeLeft: (time) => `Restam ${time}`,
  drops: (n) => `${n} gotas`,

  resultClear: 'Passou',
  resultFail: 'Não passou',
  clearTitle: 'A água passou',
  fail: {
    time: 'O tempo acabou',
    moves: 'Não há mais giros',
    drywell: 'A água caiu no poço seco',
    water: 'A água acabou',
    deadend: 'A água caiu num trecho sem saída',
  },
  extendByAd: 'Ver um anúncio por mais 30 segundos',
  extendByDrops: (cost) => `${cost} gotas por mais 30 segundos`,
  multiplyByAd: (mult) => `Ver um anúncio por ×${mult} gotas`,

  stages: 'Fases',
  settingsAria: 'Ajustes',
  menuAria: 'Menu',
  back: 'Voltar',
  loop1: 'Primeira volta',
  loop2: 'Segunda volta',
  loopNote: 'A segunda volta aperta os giros e o tempo. Os registros ficam separados.',
  shop: 'Loja',
  groupMain: 'Principal',
  groupExtra1: 'Extras',
  groupExtra2: 'Extras II',
  freeTrial: 'Grátis',
  notPurchased: (n, name) => `${n} ${name} (bloqueada)`,
  lockedStage: 'Fase bloqueada',
  extraLockedFree: 'A fase 1, “A queda ao contrário”, é grátis. As outras abrem com a compra em Ajustes (≡).',
  extraLocked: 'Abre com a compra em Ajustes (≡).',
  extra2Locked: 'A partir da fase 11, abre quando a água tiver passado nas fases 1–10.',
  extra2LockedUnowned: 'Compre em Ajustes (≡) e conclua as fases 1–10 para abrir a partir da 11.',
  extra2Note: 'Abre quando a água tiver passado em todos os Extras.',
  progress: (cleared, total) => `Principal ${cleared} / ${total} concluídas`,
  totalTime: (time) => `Total ${time}`,
  totalNone: 'Total —',

  settings: 'Ajustes',
  bgm: 'Ambiente',
  se: 'Efeitos',
  testSound: 'Testar o som',
  audioStatus: (state) => `Som: ${state}`,
  audioState: {
    locked: 'Travado (toque a tela uma vez para ativar)',
    running: 'Ativo',
    suspended: 'Em pausa',
  },
  demoNote: (n) => `Estas ${n} fases são a demo na web. As 42 estão no app.`,
  demoGet: 'Baixar na App Store',
  // — 今日の一面（日替わり）
  dailyTitle: 'Fase do dia',
  dailyLoading: 'Carregando…',
  dailyOffline: 'Sem conexão: a fase do dia não pode abrir',
  dailyPlay: 'Jogar',
  dailyCleared: (time: string) => `Concluída em ${time}`,
  archiveTitle: 'Fases anteriores',
  upcomingTitle: 'Próximas fases',
  archiveLocked: 'Os últimos 3 dias são grátis. Compre os Extras para abrir todas as anteriores',
  language: 'Idioma',
  languageAuto: 'Seguir o aparelho',
  palette: 'Paleta',
  worn: 'Em uso',
  owned: 'Adquirida',
  buyDrops: 'Comprar gotas',
  restore: 'Restaurar compras',
  writeReview: 'Avaliar este app',
  moreApps: 'Mais do mesmo autor',
  restoreChecking: 'Verificando…',
  restoreDone: (n) => `${n} restauradas`,
  restoreNone: 'Não há nada a restaurar',
  restoreFailed: 'Não foi possível restaurar',
  chooseStage: 'Escolher uma fase',
  resume: 'Continuar',

  prizeLabel: 'Recompensa',
  awardLabel: 'Título',
  toExtra: 'Para os Extras',
  toLoop2: 'Para a segunda volta',
  toStart: 'Para o início',
  allClearTitle: 'Percorrido',
  allClearBody: (n) => `A água passou por todos os ${n} canais`,
  multiplyTimes: (mult) => `Ver um anúncio por ×${mult}`,
  noteRank: 'O título fica no registro e aparece acima da lista de fases.',
  noteLoop2: 'A segunda volta está aberta. Os giros e o tempo apertam mais.',
  notePartOne: 'Até aqui é a Parte Um. A água ainda não subiu.',
  inviteTry: 'Experimentar o Extra 1',
  inviteOpen: 'Abrir Extras I — 20 fases',
  dateLine: (d) =>
    `${d.getDate()} de ${['janeiro','fevereiro','março','abril','maio','junho','julho','agosto','setembro','outubro','novembro','dezembro'][d.getMonth()]} de ${d.getFullYear()}`,

  completionTitle: 'Quem atravessou o infinito',
  rank: {
    none: '—',
    sovereign: 'Soberano da água',
    architect: 'Arquiteto das quedas',
    mason: 'Canteiro',
    apprentice: 'Aprendiz',
    wayfarer: 'Viandante',
  },

  skin: {
    hakushi: 'Papel em branco',
    ai: 'Anil',
    koke: 'Musgo',
    shu: 'Vermelhão',
    sumi: 'Tinta sumi',
  },

  product: {
    drops600: '600 gotas',
    drops1600: '1.600 gotas',
    drops5000: '5.000 gotas',
    noads: 'Remover os anúncios',
    extras: 'Extras I — 21 fases (sem anúncios)',
  },
};
